import React from 'react'
import Layout from '../../components/layout/Layout'
import OrderReportTable from '../../elements/tables/reports/OrderReportTable'

export default function OrderReport() {
  return (
    <div>
      <Layout>
        <OrderReportTable />
      </Layout>
    </div>
  )
}
